import { Pipe, PipeTransform } from '@angular/core';

import { PlaylistItemDTO } from '../models/view-models/playlist-item-models/playlist-item-dto.model';

@Pipe({
  name: 'isAnyPlaylistItemProcessing',
  standalone: true
})
export class IsAnyPlaylistItemProcessingPipe implements PipeTransform {

  transform(items: PlaylistItemDTO[], timeSpan: Date): boolean {

    if (!items) {
      return false;
    }

    return items.some(item =>
      item.PlaylistItemLinks.some(source => source.isConverting));
  }

}
